export const GET_HOME_TEXT_SECTION = `
  query getHomeTextSection {
    getHomeTextSection {
      __typename
      ... on HomeTextSectionResponse {
        id
        title
        content
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;